import { Grid, Typography } from '@mui/material'
import errorMsgIcon from "../../../src/assets/Images/errorMessageIcon.svg"
import globalStyles from "../../Styles/ComponentStyles/global.module.scss"
import { useLocation, useNavigate } from 'react-router-dom'

const ErrorShowingDialog = () => {

  const navigate = useNavigate();
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get('user_id');

  const handleUpdateProfileClick = () => {
    navigate(`/profile/newProfile/iul?user_id=${userId}`);
  }

  return (
    <>
      <Grid container className={globalStyles.errorDialogContainer}>
        <Grid item>
          <Grid container gap={"20px"}>
            <Grid item>
              <img src={errorMsgIcon} alt="" />
            </Grid>
            <Grid item >
              <Grid container>
                <Grid item xs={12} className={globalStyles.errorTitle} >
                  Error
                </Grid>
                <Grid item xs={12} className={globalStyles.errorDescription} >
                  Please check the input data and fix the issue.
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Typography
            component={"span"}
            style={{ color: "rgba(0, 0, 255, 1)", fontSize: "16px", fontWeight: "600", textDecoration: "underline", cursor: "pointer" }}
            onClick={handleUpdateProfileClick}
          >
            Update Profile
          </Typography>
        </Grid>
      </Grid>
    </>
  )
}

export default ErrorShowingDialog;
